import PropTypes from 'prop-types';
import { useCallback } from 'react';
import PopConfirm from '../../Molecules/PopConfirm';
import Hyperlink from '../Hyperlink';

/*
#tailwind
*/

const ExternalHyperlink = ({ url, underlined, children, className, ...other }) => {
  const onConfirm = useCallback(() => {
    window.open(url);
  }, [url]);

  return (
    <PopConfirm
      title="Following this link opens a new browser tab and sends you to a website outside of Socialive."
      onConfirmButtonClick={onConfirm}
      testId="chat-external-hyperlink"
      confirmButtonText="OK"
      cancelButtonText="Cancel"
    >
      <Hyperlink href={url} underlined={underlined} {...other}>
        {children}
      </Hyperlink>
    </PopConfirm>
  );
};

ExternalHyperlink.propTypes = {
  url: PropTypes.string,
  underlined: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

ExternalHyperlink.defaultProps = {
  url: undefined,
  underlined: true,
  children: undefined,
  className: undefined,
};

export default ExternalHyperlink;
